//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MtModal from '@/components/Modal/MtModal'
export default {
  components: {
    MtModal
  },
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    like: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    picture: {
      type: String,
      default: ''
    },
    itemsCount: {
      type: [Number, String],
      default: 0
    },
    sex: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      scrolled: false,
      dark: false,
      darkObserver: null,
      modal: null
    }
  },
  computed: {
  },
  mounted() {
    this.createObserver()
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll ()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, false);
    this.deleteObserver()
  },
  methods: {
    actionLike() {
      if (!this.$cookies.get('token')) {
        setTimeout(() => {this.$store.commit('sidebars/loginAsideOpen')}, 100)
      } else {
        this.$axios({
          method: 'post',
          url: '/api/v1/collection/addVote',
          data: `lang=${this.$i18n.locale || 'ru'}&userId=${this.$route.params.id}`
        })
          .then(({data}) => {
            if (data.error) {
              this.modal = {
                message: data.error.message,
                status: this.$t('profileAvatar.error')
              }
            } else {
              this.modal = {
                message: this.$t('profileAvatar.votedModalTitle'),
                status: this.$t('profileAvatar.votedModalSuccessStatus'),
                color: 'light'
              }
              this.$emit('like')
            }
          })
          .catch(err => {
            console.log('ERORRRR', err)
          })
      }
    },
    handleScroll () {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop
      this.scrolled = currentScroll > 50
    },
    pictureUrl (url) {
      if (url){
        return this.$absoluteImageUrl(url)
      }
      switch(this.sex) {
        case ('Мужской' || 'Male'):
          return 'images/default-male-avatar.svg'
          break
        case ('Женский' || 'Female'):
          return 'images/default-female-avatar.svg'
          break
        default:
          return 'images/default-male-avatar.svg'
          break
      }
    },
    deleteObserver() {
      document.querySelectorAll('.dark-trigger').forEach(elem => {
        if(this.darkObserver) {
          this.darkObserver.unobserve(elem);
        }
      })
    },
    createObserver() {
      const profileAside = document.querySelector('.profile-info-avatar')
      setTimeout(() => {
        const profileAsideOffset = profileAside.offsetHeight + profileAside.offsetTop
        const margin = (window.innerHeight - profileAsideOffset) * -1 + 'px'
        const options = {
          root: null,
          rootMargin: `1px 0px ${margin} 0px`,
          threshold: 0
        }

        this.darkObserver = new IntersectionObserver((entries, observer) => {
          for(let i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              this.dark = true
              return
            }
          }
          this.dark = false
        }, options)

        document.querySelectorAll('.dark-trigger').forEach(elem => {
          this.darkObserver.observe(elem)
        })
      }, 500)
    },
    updatePhoto(e) {
      const files = e.target.files
      if (files.length) {
        const data = new FormData();
        data.append("picture", files[0]);
        this.$axios({
          method: 'post',
          url: `/api/v1/personnel/update/?lang=${this.$i18n.locale || 'ru'}`,
          data
        })
          .then(({data}) => {
            this.$emit('editing')
            this.$store.commit('changeNeedUpdatePhoto', true)
          })
          .catch(err => {
            console.log('ERORRRR', err)
          })
      }
    }
  }
}
